module.exports = __webpack_public_path__ + "static/img/a7.54ffceec.png";